import { ActionCard } from '@components/ui';
import styled from 'styled-components';
import { flexCenter } from '../../../../helpers/style-helpers';

export const ClinicalDataSC = styled.div`
  ${ActionCard.Button} {
    margin-bottom: 16px;
  }
`;

export const ClinicalItemSC = styled.div`
  display: flex;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 0 16px 0 rgba(51, 61, 108, 0.1);
  margin-bottom: 16px;
  padding: 16px;
  align-items: center;
  height: 56px;
  color: #333d6d;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  .ci-count {
    ${flexCenter}

    margin-left: auto;
    width: 60px;
    height: 24px;
    border-radius: 12px;
    background: rgba(51, 61, 108, 0.1);
  }

  .ci-icon {
    ${flexCenter}

    position: relative;
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

  .ci-notification {
    position: absolute;
    top: -8px;
    right: -8px;
  }
`;
